import { useSelector } from 'react-redux';
import { geNotificationsDrawerParamsSelector } from 'store/selectors/drawers/notifications';
import {
  getGroupedNotificationsSelector,
  getNotificationsPaginationSelector,
} from 'store/selectors/sockets/notifications';
import { getUserRolesMapSelector } from 'store/selectors/user';

import ByDate from './Notification/ByDate';
import ByUser from './Notification/ByUser';

import { NotificationsSkeleton } from './NotificationsSkeleton';
import { IDLE } from 'settings/constants/apiState';

const Notifications = () => {
  const { isClient } = useSelector(getUserRolesMapSelector);
  const drawerParams = useSelector(geNotificationsDrawerParamsSelector);
  const { loadingState } = useSelector(getNotificationsPaginationSelector);
  const groupedNotificationsByDate = useSelector(
    getGroupedNotificationsSelector({ filter: drawerParams?.filter, isClient }),
  );

  const isIdle = loadingState === IDLE;

  const getContent = () => {
    const { currentNotificationsUser, type } = drawerParams || {};

    if (currentNotificationsUser && type) {
      const notificationsList = Object.values(groupedNotificationsByDate)?.flat() || [];
      const notificationsData = notificationsList.find(
        (notific) => notific?.Id === currentNotificationsUser,
      );
      return (
        <ByUser
          groupedNotificationsByUser={notificationsData?.notifications?.list}
          name={notificationsData?.name}
          avatarUrl={notificationsData?.avatarUrl}
          groupType={type}
        />
      );
    }

    return <ByDate groupedNotificationsByDate={groupedNotificationsByDate} />;
  };

  return isIdle ? <NotificationsSkeleton /> : getContent();
};

export default Notifications;
